import FeatureGates from "@atlaskit/feature-gate-js-client";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { useLoggedInHasJira, useJiraD0to6 } from "@/components/user-context";
import { IntercomProvider } from "@/libraries/intercom/src";
import { OrganicD1to6LoggedInJiraProductTourOverview } from "@/templates/jira-product-tour-overview/src/sections/productionized/organic-d1to6-logged-in/organic-d1to6-logged-in-jira-product-tour-overview.template";
import { LoggedInJiraProductTourOverview } from "@/templates/jira-product-tour-overview/src/templates";
import { LoggedOutOrNoJiraProductTourOverview } from "@/templates/software/jira/logged-out/jira-software-logged-out-page/src";

export const JiraSoftwarePage = () => {
    const loggedInHasJira = useLoggedInHasJira();
    const jiraD0to6 = useJiraD0to6();

    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    const template = jiraD0to6 ? (
        <OrganicD1to6LoggedInJiraProductTourOverview />
    ) : loggedInHasJira ? (
        <LoggedInJiraProductTourOverview />
    ) : (
        <LoggedOutOrNoJiraProductTourOverview />
    );

    return (
        <UFOSegment name="jira-product-tour-overview">
            <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
                <CrossFlowTouchpointProvider
                    productKeys={[ProductKeys.JIRA_SOFTWARE]}
                    screenName="wacJswProductTourPage"
                >
                    {template}
                </CrossFlowTouchpointProvider>
            </IntercomProvider>
        </UFOSegment>
    );
};
